import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { USER_DAL } from '~/modules/common/enums';
import { PAGE_SIZE } from '~/modules/common/const';

const effectiveDataAccessLevelUris = [
  USER_DAL.PROJECT_MANAGER,
  USER_DAL.RESOURCE_MANAGER,
  USER_DAL.RESOURCE_POOL_MANAGER
];

export const PAGE_OF_RESOURCE_USERS_DROPDOWN_QUERY = gql`
  query pageOfResourceUsersDropdownOptionsForUserDropdown(
    $input: PageOfResourceUsersDropdownOptionsInput!
  ) {
    pageOfResourceUsersDropdownOptions(input: $input) {
      id
      displayText
    }
  }
`;

const useResourceUsersDropdownOptions = ({ searchTerm, skip }) => {
  const { data, loading } = useQuery(PAGE_OF_RESOURCE_USERS_DROPDOWN_QUERY, {
    variables: {
      input: {
        page: 1,
        pagesize: PAGE_SIZE + 1,
        filter: {
          name: searchTerm || undefined,
          effectiveDataAccessLevelUris
        }
      }
    },
    context: {
      debounceKey: 'resource-users-dropdown-search',
      debounceTimeout: 250
    },
    fetchPolicy: 'cache-and-network',
    skip
  });

  const users = data?.pageOfResourceUsersDropdownOptions || [];

  return {
    loading,
    hasMore: users.length > PAGE_SIZE,
    options: users.slice(0, PAGE_SIZE)
  };
};

export default useResourceUsersDropdownOptions;
